import axios, { AxiosError, AxiosRequestConfig } from 'axios'

import { IAdministratorSave, ISubscriberSave } from 'providers/ISubscriberProvider.d'
import getToken from 'utils/authentication'
import {
  IValidateToken,
  IResendEmail,
  IReturnValidateToken,
  PasswordAgeResolve,
  IResponseGeneric,
  IFindInObSib,
  IGetPlans,
  IPostPlans,
  IGetSelectedPlan,
  IValidateCollaborator,
  ISuscriberGet,
  IUpdatePassword,
  ISaveCollaborators,
  IResponseAppKeys,
  IResponseApplicationStatus,
  IResponseIvaList,
  IResponseIibbList,
  IPostCollaboratorConfirmation,
  IPostValidateAdministrator,
  IPostAdministratorConfirmation,
  IFetchedOfferingsB,
  IResponseGetAccount,
  IPostCollaboratorReConfirmation,
  ISaveOffering,
  IFetchedOfferingsSelected,
  IFetchedAdditionalServices,
  ISaveBanks,
  IFetchedGetSelectedBanks,
  IFetchedGetDashborad,
  IFetchedGetResume,
  IFetchedValidatedCompany,
  ICompany,
  IFetchedSaveCompany,
  IFetchedGetCompany,
  IFetchedCompanies,
  IDashboardParams,
  IFetchedCollaboratorInformation,
  IPostSubscription,
  ResponseIStatusBanks,
  ISendEmailRecoveryPassword,
  IReturnSendEmailRecoveryPassword,
  IFetchedFindInObSib,
  IValidateAdministrator,
  ILegalRepresentativeParams,
  IGetFileData,
} from './IApi.d'

import subscriberInformation from '../__mocks__/subscriber/subscriber.json'
import passwordAge from '../__mocks__/subscriber/passwordAge.json'
import validatePassword from '../__mocks__/validatePassword/validatePassword.json'
import banckAcoounts from '../__mocks__/banks/banksAccounts.json'
import { ERROR_500, ERROR_MESSAGE } from './apiData'

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['User-key'] = process.env.REACT_APP_API_USER_KEY

if (process.env.NODE_ENV === 'development') {
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
}
axios.interceptors.request.use(async config => {
  let token = getToken()
  const myConfig = config
  if (myConfig.headers.Authorization) {
    return myConfig
  }

  if (token) {
    myConfig.headers.Authorization = `Bearer ${token}`
  } else {
    setTimeout(() => {
      token = getToken()
    }, 3000)
    myConfig.headers.Authorization = `Bearer ${token}`
  }
  return myConfig
})

export const SUCCESS_STATUS = [200, 201]
export const INTERNAL_ERROR_STATUS = [500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511]

const get = async (uri: string, options?: AxiosRequestConfig<unknown>) => {
  try {
    const response = await axios.get(uri, options)
    return response
  } catch (error) {
    return { status: error.code, data: error.message }
  }
}
const getCatch = async (uri: string, options?: AxiosRequestConfig<unknown>) => {
  try {
    const response = await axios.get(uri, options).catch((reason: AxiosError) => {
      const status = reason.response?.status ?? reason.code
      const data = reason.response?.data ?? reason.message
      return { status, data }})
    return response
  } catch (error) {
    return { status: error.code, data: error.message }
  }
}
const post = async (uri: string, params?: unknown, options?: AxiosRequestConfig<unknown>) => {
  try {
    const response = await axios.post(uri, params, options).catch((reason: AxiosError) => {
      const status = reason.response?.status ?? reason.code
      const data = reason.response?.data ?? reason.message
      return { status, data }
    })
    return response
  } catch (error) {
    return { status: error.code, data: error.message }
  }
}

const put = async (uri: string, params?: unknown, options?: AxiosRequestConfig<unknown>) => {
  return axios.put(uri, params, options).catch((reason: AxiosError) => {
    if (reason.response) {
      return { status: reason.response.status ?? ERROR_500, data: reason.response.data ?? ERROR_MESSAGE};
    } else {
      return { status: Number(reason.code ?? ERROR_500), data: reason.message ?? ERROR_MESSAGE};
    }  
  }).catch(err => { return { status: err.code || ERROR_500, data: err.message || ERROR_MESSAGE }; })
};


const patch = async (uri: string, params?: unknown, options?: AxiosRequestConfig<unknown>) => {
  try {
    return await axios.patch(uri, params, options)
  } catch (error) {
    return { status: error.code, data: error.message }
  }
}

// Collaborator enpoints
export const getRoles = async (): Promise<IResponseGeneric> => {
  const response: any = await get('/colaborador/rol')
  return { status: response?.status, data: response?.data }
}
export const validateCollaborator = async (collaborator: IValidateCollaborator): Promise<IResponseGeneric> => {
  const source = axios.CancelToken.source()
  const timeoutId = setTimeout(() => {
    source.cancel()
  }, 8000)
  const response: any = await get('/colaborador/persona', { params: { ...collaborator }, cancelToken: source?.token })
  clearTimeout(timeoutId)
  return { status: response?.status, data: response?.data }
}

export const collaboratorList = async (subscriberId: string, companyId: string): Promise<IResponseGeneric> => {
  const response: any = await get('/colaborador/listar', { params: { idSuscriptor: subscriberId, idEmpresa: companyId } })
  return { status: response?.status, data: response?.data }
}

export const saveCollaborator = async (collaborators: ISaveCollaborators[]): Promise<IResponseGeneric> => {
  const response: any = await put('/colaborador', collaborators)
  return { status: response?.status, data: response?.data }
}

export const getCollaboratorInformation = async (idColaborador: string): Promise<IFetchedCollaboratorInformation> => {
  const response: IFetchedCollaboratorInformation = await get('/colaborador/id', { params: { idColaborador } })
  return response
}

export const postValidateEmailExist = async (emailExist: string, recaptchaToken: string): Promise<IResponseGeneric> => {
  const response: IResponseGeneric = await post('/colaborador/existe-email', { email: emailExist }, { headers: { 'x-recaptcha-token': recaptchaToken } })
  return { status: response?.status, data: response?.data }
}

// Offering endpoints

export const getOfferings = async (): Promise<IFetchedOfferingsB> => {
  const response: any = await get('/v2/offering/all')
  return { status: response?.status, data: response?.data }
}

export const getOffering = async (subscriberId: any, companyId: any): Promise<IFetchedOfferingsSelected> => {
  const response: any = await get(`/v2/offering/subscriber/${subscriberId}/company/${companyId}`)
  return { status: response?.status, data: response?.data }
}

export const saveOfferings = async (offeringsSelected: ISaveOffering[], options?: AxiosRequestConfig<unknown>): Promise<IResponseGeneric> => {
  const response: IResponseGeneric = await post('/v2/offering', offeringsSelected, options)
  return response
}

export const updateOfferings = async (offeringsSelected: ISaveOffering[], options?: AxiosRequestConfig<unknown>): Promise<IResponseGeneric> => {
  const response: IResponseGeneric = await put('/v2/offering', offeringsSelected, options)
  return response
}

export const getCompanies = async (subscriberId: string): Promise<IFetchedCompanies> => {
  const response: any = await get(`/v2/company/subscriberId/${subscriberId}`)
  return { status: response?.status, data: response?.data }
}

// Additional Services endpoint

export const getAdditionalServicesPlan = async (codeDn: string): Promise<IFetchedAdditionalServices> => {
  const response: any = await get(`/v2/offering/codeDN/${codeDn}`)
  return { status: response?.status, data: response?.data }
  // return services
}

export const getResumen = async (subscriberId: any, companyId: any): Promise<IFetchedGetResume> => {
  const response: IFetchedGetResume = await get(`/summary/subscriberId/${subscriberId}/companyId/${companyId}`)
  return response
}

export const getAccounts = () =>
  new Promise<any>((resolve: any) => {
    setTimeout(() => resolve(banckAcoounts), 2000)
  })

export const postPlans = async (body: IPostPlans[], options?: AxiosRequestConfig<unknown>): Promise<IResponseGeneric> => {
  const response: any = await post('/offering', body, options)
  return { status: response?.status, data: response?.data }
}

export const postPlansBank = async (body: IPostPlans[], options?: AxiosRequestConfig<unknown>): Promise<IResponseGeneric> => {
  const response: any = await post('/offering/bank', body, options)
  return { status: response?.status, data: response?.data }
}

export const updatePlans = async (body: IPostPlans[], options?: AxiosRequestConfig<unknown>): Promise<IResponseGeneric> => {
  const response: any = await put('/offering', body, options)
  return { status: response?.status, data: response?.data }
}

export const getSelectedPlan = async (data: IGetSelectedPlan): Promise<IResponseGeneric> => {
  const response: any = await get('/offering', { params: data })
  return { status: response?.status, data: response?.data }
}

export const postAccounts = async (params: ISaveBanks, options?: AxiosRequestConfig<unknown>): Promise<{ status: number }> => {
  const response: any = await post('/bank', params, options)
  return { status: response?.status }
}

export const getAccountsSib = async (params: unknown, options?: AxiosRequestConfig<unknown>) => {
  const response: any = await post('/bancos/consulta', params, options)
  return { status: response?.status, data: response?.data }
}

export const getselectedBanks = async (subscriberId: string, companyId: string): Promise<IFetchedGetSelectedBanks> => {
  const response: IFetchedGetSelectedBanks = await get(`/bank/subscriberId/${subscriberId}/companyId/${companyId}`)
  return response
}

export const putAccounts = async (params: unknown, options?: AxiosRequestConfig<unknown>) => {
  const response: any = await put('/bancos', params, options)
  return { status: response?.status, data: response?.data }
}

export const getPlans = async (cuit: IGetPlans): Promise<IResponseGeneric> => {
  const response: any = await get('/offerings', { params: cuit })
  return { status: response?.status, data: response?.data }
}

export const getBanksList = async (cuit: string, companyId: string): Promise<IResponseGetAccount> => {
  const response: IResponseGetAccount = await getCatch(`/bank/cuit/${cuit}/companyId/${companyId}`)
  return response
}

export const getBanksListSelect = async (data: IGetSelectedPlan): Promise<IResponseGeneric> => {
  const response: any = await post('/bancos/consulta', { ...data })
  return { status: response?.status, data: response?.data }
}

// Company endpoints
export const getCategoryIva = async (): Promise<IResponseIvaList> => {
  const response: any = await get('/iva')
  return { status: response?.status, data: response?.data }
}

export const getCategoryIIBB = async (): Promise<IResponseIibbList> => {
  const response: any = await get('/iibb')
  return { status: response?.status, data: response?.data }
}

export const getProvincias = async (): Promise<IResponseGeneric> => {
  const response: any = await get('/provincias')
  return { status: response?.status, data: response?.data }
}

export const getInformationCompanyAfip = async (cuit: string) => {
  const response: any = await get('/company/afip', { params: { cuit } })
  return { status: response?.status, data: response?.data }
}

export const updateCompany = async (data: ICompany, options?: AxiosRequestConfig<unknown>) => {
  const response: any = await put('/v2/company', data, options)
  return response
}

export const saveCompany = async (data: ICompany, options?: AxiosRequestConfig<unknown>): Promise<IFetchedSaveCompany> => {
  const response: IFetchedSaveCompany = await post('/v2/company', data, options)
  return response
}

export const validateCompany = async (cuit: string): Promise<IFetchedValidatedCompany> => {
  const response: IFetchedValidatedCompany = await get(`/v2/company/cuit/${cuit}/validate`)
  return response
}

export const getCompany = async (companyId: string): Promise<IFetchedGetCompany> => {
  const response: IFetchedGetCompany = await get(`/v2/company/companyId/${companyId}`)
  return response
}

export const postValidatePassword = (value: any) =>
  new Promise<any>((resolve: any) => {
    if (value) {
      setTimeout(() => {
        resolve(validatePassword[value])
      }, 1000)
    }
  })

// Dashboard endpoints
export const getDashboard = async (subscriberId: string, companyId: string): Promise<IFetchedGetDashborad> => {
  const params: IDashboardParams = { subscriberId, ...(companyId ? { companyId } : {}) }
  const response: IFetchedGetDashborad = await get('/dashboard', { params })
  return response
}

export const postCollaboratorConfirmation = async (subscriberId: string, companyId: string): Promise<IPostCollaboratorConfirmation> => {
  const response: any = await post('/colaboradorConfirmacion', {
    idEmpresa: companyId,
    idSuscriptor: subscriberId,
  })
  return { status: response?.status, data: response?.data }
}

export const postCollaboratorReConfirmation = async (subscriberId: string, companyId: string): Promise<IPostCollaboratorReConfirmation> => {
  const response: any = await post('/resend-email', {subscriberId,companyId})
  return { status: response?.status, data: response?.data }
}

export const postAdministratorConfirmation = async (subscriberId: string, companyId: string): Promise<IPostAdministratorConfirmation> => {
  const response: any = await post('/administrador/enviarSolicitud', {
    idEmpresa: companyId,
    idSuscriptor: subscriberId,
  })
  return { status: response?.status, data: response?.data }
}

export const postCollaboratorConfirmationConfirm = async (subscriptionData: ILegalRepresentativeParams, options?: AxiosRequestConfig<unknown>): Promise<IResponseGeneric> => {
  const { collaboratorId, companyId, subscriberId } = subscriptionData
  const token = getToken()
  const newOptions: AxiosRequestConfig<unknown> = {
    ...options,
    headers: {
      ...options?.headers,
      token: options?.headers?.token || token,
      Authorization: options?.headers?.Authorization || `Bearer ${token}`,
    }
  }
  const response: any = await post('/legal-representative/confirmation', {
    collaboratorId,
    companyId,
    subscriberId,
  }, newOptions)
  return { status: response?.status, data: response?.data }
}

export const getFileRequirement = async (fileData: IGetFileData, options?: AxiosRequestConfig<unknown>): Promise<IResponseGeneric> => {
  const { companyCuit, collaboratorId } = fileData
  const newOptions: AxiosRequestConfig<unknown> = {
    ...options,
    responseType: 'blob',
  }
  const response: any = await get(`/file/requirement/cuit/${companyCuit}/collaboratorId/${collaboratorId}`, newOptions)
  return { status: response?.status, data: response.data }
}

export const getFileTerms = async (fileData: IGetFileData, options?: AxiosRequestConfig<unknown>): Promise<IResponseGeneric> => {
  const { companyCuit, collaboratorId } = fileData
  const newOptions: AxiosRequestConfig<unknown> = {
    ...options,
    responseType: 'blob',
  }
  const response: any = await get(`/file/termsandconditions/cuit/${companyCuit}/collaboratorId/${collaboratorId}`, newOptions)
  return { status: response?.status, data: response.data }
}

export const postSubscriber = async (data: ISubscriberSave, options?: AxiosRequestConfig<unknown>) => {
  const newOptions: AxiosRequestConfig<unknown> = {
    ...options,
    headers: {
      ...options?.headers,
      token: options?.headers?.token || getToken(),
      Authorization: options?.headers?.Authorization || `Bearer ${getToken()}`,
    }
  }
  const response: any = await post('/suscriptor', data, newOptions)
  return { status: response?.status, data: response?.data }
}

export const postAdministrator = async (data: IAdministratorSave, options?: AxiosRequestConfig<unknown>) => {
  const token = getToken()
  const newOptions: AxiosRequestConfig<unknown> = {
    ...options,
    headers: {
      ...options?.headers,
      token: options?.headers?.token || token,
    }
  }
  const response: any = await post('/administrador', data, newOptions)
  return { status: response?.status, data: response?.data }
}

export const getSubscriber = async (subscriber: ISuscriberGet): Promise<IResponseGeneric> => {
  const response: any = await get('/suscriptor', { params: subscriber })
  return { status: response?.status, data: response?.data }
}

export const validateToken = async (params: IValidateToken, options?: AxiosRequestConfig<unknown>) => {
  const response: any = await put('/suscriptor/token', params, options)
  return { status: response?.status, data: response?.data }
}

export const validateTokenValidate = async (
  params: IValidateToken,
  options?: AxiosRequestConfig<unknown>,
): Promise<IReturnValidateToken> => {
  const newOptions: AxiosRequestConfig<unknown> = {
    ...options,
    baseURL: process.env.REACT_APP_API_BASE_URL_UNSEC,
    headers: {
      ...options.headers,
      'User-key': process.env.REACT_APP_API_USER_KEY_UNSEC
    }
  }
  const response: any = await post('/suscriptor/token/validate', params, newOptions)
  return { status: response?.status, data: response?.data }
}

export const expiredToken = async (colaboradorId: string, role:number, options?: AxiosRequestConfig<unknown>,): Promise<IReturnValidateToken> => {
  const newOptions: AxiosRequestConfig<unknown> = {
    ...options,
    baseURL: process.env.REACT_APP_API_BASE_URL_UNSEC,
    headers: {
      ...options.headers,
      'User-key': process.env.REACT_APP_API_USER_KEY_UNSEC
    }
  }
  const response: any = await patch(`/colaborador/${colaboradorId}/role/${role}/expirar`, '', newOptions)
  return { status: response?.status, data: response?.data }
}

export const resendEmail = async (params: IResendEmail, options?: AxiosRequestConfig<unknown>): Promise<IReturnValidateToken> => {
  const response: any = await post('/suscriptor/correoValidacion', params, options) 
  return { status: response?.status, data: response?.data }
}

export const postUpdatePassword = async (data: IUpdatePassword) => {
  const token = getToken()
  const response: any = await put('/password-recovery', data, { headers: { token } })
  return { status: response?.status, data: response?.data }
}

export const validatePasswordAge = (password: string) =>
  new Promise<PasswordAgeResolve>((resolve: any) => {
    setTimeout(() => {
      if (password) resolve(passwordAge)
    }, 1000)
  })

export const postCancelSubscription = async (subscriberId: string, companyId: any): Promise<IResponseGeneric> => {
  const response: any = await post('/suscripcion/delete', {
    idEmpresa: companyId,
    idSuscriptor: subscriberId,
  })
  return { status: response?.status, data: response?.data }
}

export const findInOb2Sib = async (subscriber: IFindInObSib, recaptchaToken: string): Promise<IFetchedFindInObSib> => {
  const response: IFetchedFindInObSib = await get(
    '/suscriptor/findInOb2Sib',
    {
      params: subscriber,
      baseURL: process.env.REACT_APP_API_BASE_URL_UNSEC,
      headers: {
        'User-key': process.env.REACT_APP_API_USER_KEY_UNSEC,
        'x-recaptcha-token': recaptchaToken,
      }
    }
  )
  return response
}

export const getApplicationKeys = async (): Promise<IResponseAppKeys> => {
  const response: IResponseAppKeys = await get('/v2/application-key')
  return response
}

export const getApplicationStatus = async (subscriberId: any, companyId: any): Promise<IResponseApplicationStatus> => {
  const response: any = await get('/application/status', { params: { idSuscriptor: subscriberId, idEmpresa: companyId } })
  return { status: response?.status, data: response?.data }
}

export const postSuscriptionDocuments = async (subscriberId: any, companyId: any): Promise<IResponseGeneric> => {
  const response: any = await get(`/subscription/documents/subscriber/${subscriberId}/company/${companyId}`, { responseType: 'blob' })
  return { status: response?.status, data: response?.data }
}

export const postSuscriptionStatus = async (subscriberId: any, companyId: any): Promise<IResponseGeneric> => {
  const response: any = await post('/suscripcion/estado', {
    idEmpresa: companyId,
    idSuscriptor: subscriberId,
  })
  return { status: response?.status, data: response?.data }
}

export const postSuscriptionStatusBanks = async (subscriberId: string, companyId: string): Promise<ResponseIStatusBanks> => {
  const response: ResponseIStatusBanks = await get(`/subscription/bank-status/subscriber/${subscriberId}/company/${companyId}`)
  return response
}

export const postValidateAdministrator = async (adminData: IValidateAdministrator, options?: AxiosRequestConfig<unknown>): Promise<IPostValidateAdministrator> => {
  const data = {
    idColaborador: adminData.collaboratorId,
    nacionalidad: adminData.nationality,
    numeroDocumento: adminData.document,
    tipoDocumento: adminData.tipoDocumento,
  }
  const response: any = await post('/administrador/validar', data, options)
  return { status: response?.status, data: response?.data }
}

export const getSubscriberInformation = cuit =>
  new Promise<any>((resolve: any) => {
    if (cuit) {
      setTimeout(() => {
        resolve({ status: 200, subscriberInformation })
      }, 1000)
    }
  })

export const postSubscription = async (subscriberId: string, companyId: string): Promise<IPostSubscription> => {
  const response: IResponseGeneric = await post('/subscription', { companyId, subscriberId })
  return response
}

export const postSendEmailRecoveryPassword = async (dataEmailRecoveryPassword: ISendEmailRecoveryPassword, options?: AxiosRequestConfig<unknown>): Promise<IReturnSendEmailRecoveryPassword> => {
  const response: any = await post('/password-recovery/send-email', dataEmailRecoveryPassword, {
    ...options,
    baseURL: process.env.REACT_APP_API_BASE_URL_UNSEC,
    headers: {
      ...options.headers,
      'User-key': process.env.REACT_APP_API_USER_KEY_UNSEC
    }
  })
  return { status: response?.status, data: response?.data }
}
